export const locales = ['en', 'fi', 'sv', 'de', 'fr', 'es', 'nl'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'en';

export const localeMeta: Record<Locale, { label: string; flag: string }> = {
  en: { label: 'English', flag: '🇬🇧' },
  fi: { label: 'Suomi', flag: '🇫🇮' },
  sv: { label: 'Svenska', flag: '🇸🇪' },
  de: { label: 'Deutsch', flag: '🇩🇪' },
  fr: { label: 'Français', flag: '🇫🇷' },
  es: { label: 'Español', flag: '🇪🇸' },
  nl: { label: 'Nederlands', flag: '🇳🇱' },
};

export function isLocale(value: string | undefined): value is Locale {
  return !!value && (locales as readonly string[]).includes(value);
}
